(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("RecognitionModalCtrl", ["messageService", "$scope", "data", "$http", "$timeout", "$translate", "$state", "$window", recognitionModalCtrl]);
    function recognitionModalCtrl(messageService, $scope, data, $http, $timeout, $translate, $state, $window) {
        var vm = this;
        vm.data = data;
        vm.assignment = data.learningPath;
        vm.learnerView = data.learnerView;
        vm.contentLoaded = true;
        vm.downloading = false;
        vm.downloaded = false;
        vm.isPhone = jQuery.browser.mobile;
        vm.viewCertificate = function () {
            if (vm.downloading)
                return;
            vm.downloading = true;
            vm.downloaded = false;
            var translations = {
                certificateOfCompletionLabel: $translate.instant("account.learningPlan.recognitionItem.certificate.certificateOfCompletion"),
                hasSuccessfullyCompletedLabel: $translate.instant("account.learningPlan.recognitionItem.certificate.hasSuccessfullyCompleted"),
                registrationNumberLabel: $translate.instant("account.learningPlan.recognitionItem.certificate.registrationNumber"),
                completionDateLabel: $translate.instant("account.learningPlan.recognitionItem.certificate.completionDate"),
                expiryDateLabel: $translate.instant("account.learningPlan.recognitionItem.certificate.expiryDate"),
                LearningPathName: vm.assignment.name + " " + vm.assignment.versionName
            };
            var url = "api/learningPlan/" + vm.assignment.number + "/" + vm.assignment.version + "/certificate";
            if (!vm.learnerView)
                url = "api/learningPlan/" + vm.assignment.personSeq + "/" + vm.assignment.number + "/" + vm.assignment.version + "/certificate";
            $http.post(url, translations, { responseType: "arraybuffer" })
                .then(function (result) {
                $timeout(function () {
                    //var blob = new Blob([result.data], { type: "application/pdf" });
                    //Chrome for iOS has problems with blobs...
                    //Issue logged on: https://github.com/eligrey/FileSaver.js/issues/179
                    //saveAs(blob, "certificate.pdf");
                    //https://stackoverflow.com/questions/24485077/how-to-open-blob-url-on-chrome-ios
                    var blob = new Blob([result.data], { type: "application/pdf" });
                    if ($window.navigator.userAgent.match("CriOS")) {
                        var reader = new FileReader();
                        reader.onloadend = function () {
                            $window.open(reader.result);
                        };
                        reader.readAsDataURL(blob);
                    }
                    else {
                        window.saveAs(blob, "certificate.pdf");
                    }
                    vm.downloading = false;
                    vm.downloaded = true;
                });
            }, function () {
                messageService.error("common.genericError");
                vm.downloading = false;
            });
        };
        vm.viewBadge = function () {
            $state.go("main.accountBadgesDetails", { badgeGuid: vm.assignment.badgeDetails.badgeGuid });
        };
    }
}());
